var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import React__default, { useEffect } from "react";
import logger, { ErrorType } from "@ane/core/lib/services/logging/Logger";
import "../MessageBar/index.js";
import "../Button/index.js";
import { IconButton } from "../Button/IconButton.js";
import { MessageBarType } from "@fluentui/react/lib/MessageBar";
import { MessageBar } from "../MessageBar/MessageBar.js";
const RetryButton = ({ onRetry }) => !!onRetry ? /* @__PURE__ */ jsx(
  IconButton,
  {
    ariaLabel: "Retry",
    iconProps: {
      iconName: "Refresh"
    },
    styles: {
      root: {
        width: "auto",
        height: "16px",
        lineHeight: "16px"
      }
    },
    onClick: onRetry,
    children: "Reload"
  }
) : null;
const ErrorMessage = ({
  children,
  heading = "Error:",
  message = "An unknown error occured",
  messageBarProps,
  onRetry,
  onDismiss,
  loggingProps = {}
}) => {
  const _a = messageBarProps || {}, { actions, messageBarType = MessageBarType.error } = _a, rest = __objRest(_a, ["actions", "messageBarType"]);
  const [isExpanded, setExpanded] = React__default.useState(false);
  useEffect(() => {
    logger.error(message, ErrorType.ControlTowerError, __spreadValues({
      suppressPopup: true
    }, loggingProps));
  }, []);
  return /* @__PURE__ */ jsxs(
    MessageBar,
    __spreadProps(__spreadValues({
      ariaLabel: "",
      isMultiline: isExpanded,
      truncated: !isExpanded,
      onDismiss,
      messageBarType,
      actions: /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(RetryButton, { onRetry }),
        actions
      ] })
    }, rest), {
      onClick: () => setExpanded(!isExpanded),
      children: [
        !!heading && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("strong", { children: heading }),
          !!heading && !!message && " "
        ] }),
        !!children ? children : /* @__PURE__ */ jsx("span", { children: message })
      ]
    })
  );
};
const ValidationMessage = ({
  children,
  heading,
  message,
  messageBarProps,
  loggingProps,
  onRetry,
  onDismiss
}) => {
  const _a = messageBarProps || {}, { actions, messageBarType = MessageBarType.warning } = _a, rest = __objRest(_a, ["actions", "messageBarType"]);
  const [isExpanded, setExpanded] = React__default.useState(false);
  useEffect(() => {
    logger.warn(message, __spreadValues({}, loggingProps));
  }, []);
  return /* @__PURE__ */ jsxs(
    MessageBar,
    __spreadProps(__spreadValues({
      ariaLabel: "",
      isMultiline: isExpanded,
      truncated: !isExpanded,
      onDismiss,
      messageBarType,
      actions: /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(RetryButton, { onRetry }),
        actions
      ] })
    }, rest), {
      onClick: () => setExpanded(!isExpanded),
      children: [
        !!heading && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("strong", { children: heading }),
          !!heading && !!message && " "
        ] }),
        !!children ? children : /* @__PURE__ */ jsx("span", { children: message })
      ]
    })
  );
};
export {
  ErrorMessage,
  RetryButton,
  ValidationMessage
};
//# sourceMappingURL=ErrorMessages.js.map
